import { GoogleGenAI } from "@google/genai";

const MAX_RETRIES = 3;
const INITIAL_RETRY_DELAY = 1000;

export async function extractDataWithAI(
  base64Data: string,
  mimeType: string,
  prompt: string,
  schema: any,
  retries = 0
): Promise<any> {
  try {
    console.log(`Iniciando processamento com Gemini... (Tentativa ${retries + 1})`);
    
    // Remover o prefixo data:mime/type;base64, se existir
    let cleanBase64 = base64Data;
    if (base64Data.includes('base64,')) {
      cleanBase64 = base64Data.split('base64,')[1];
    }

    const ai = new GoogleGenAI({ apiKey: process.env.GEMINI_API_KEY });
    
    const config: any = {};
    if (schema) {
      config.responseMimeType = "application/json";
      config.responseSchema = schema;
    }

    const response = await ai.models.generateContent({
      model: "gemini-3.1-flash-lite-preview",
      contents: {
        parts: [
          {
            inlineData: {
              mimeType: mimeType,
              data: cleanBase64,
            },
          },
          {
            text: prompt,
          },
        ],
      },
      config,
    });

    const text = response.text;
    if (!text) {
      throw new Error("Resposta vazia da IA");
    }

    let result;
    try {
      result = JSON.parse(text);
    } catch (e) {
      console.error("Erro ao fazer parse do JSON:", text);
      throw new Error("A IA não retornou um JSON válido");
    }

    console.log("Processamento concluído com sucesso!", result);
    return result;
  } catch (error: any) {
    console.error("Erro no processamento com IA:", error);
    
    const errorMessage = error instanceof Error ? error.message : String(error);
    const isOverloaded = errorMessage.includes("503") || errorMessage.includes("429") || errorMessage.includes("high demand") || errorMessage.includes("UNAVAILABLE");

    if (isOverloaded && retries < MAX_RETRIES) {
      const delay = INITIAL_RETRY_DELAY * Math.pow(2, retries);
      console.log(`Servidor sobrecarregado. Tentando novamente em ${delay}ms...`);
      await new Promise(resolve => setTimeout(resolve, delay));
      return extractDataWithAI(base64Data, mimeType, prompt, schema, retries + 1);
    }

    if (isOverloaded) {
      throw new Error("O serviço de Inteligência Artificial está temporariamente sobrecarregado devido à alta demanda. Por favor, aguarde alguns instantes e tente novamente.");
    }
    
    throw new Error(`Falha ao processar documento: ${errorMessage}`);
  }
}
